module.exports = __webpack_public_path__ + "static/img/blog-1680x1050.766871e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/blog/blog-1680x1050.jpg
// module id = k8ZD
// module chunks = 47